module.exports = __webpack_public_path__ + "img/portugal.ee8223b8.svg";